export default "__VITE_ASSET__RZ9G6OCs__"